import { formatPercent } from './shared'

/**
 * Avanzamento verso il minimo d'ordine, espresso in percentuale.
 *
 * L'utente deve sapere quanto manca, non quanto vale l'ordine: il valore non esce dall'API e qui
 * non se ne parla. Quando la soglia non è impostata non si disegna nulla e lo si dice — inventare
 * un traguardo sarebbe peggio che ammettere di non conoscerlo, perché si deciderebbe su un dato
 * falso.
 */
export function ThresholdProgress({
  percent,
  missingLabel = 'Soglia non impostata',
}: {
  percent?: number | null
  missingLabel?: string
}) {
  if (percent === undefined || percent === null) {
    return (
      <div className="threshold">
        <span className="muted threshold-note">{missingLabel}</span>
      </div>
    )
  }

  const reached = percent >= 100
  // La barra si ferma a 100 anche quando la proposta è molto oltre la soglia: oltre il traguardo
  // il di più non aggiunge nulla alla decisione, e una barra che sfora si legge peggio.
  const width = Math.max(0, Math.min(100, percent))

  return (
    <div className="threshold">
      <div className="progress" title={`${formatPercent(percent)} del minimo d’ordine`}>
        <div className={`progress-fill${reached ? ' ok' : ' warn'}`} style={{ width: `${width}%` }} />
      </div>
      <span className="threshold-note muted">
        {formatPercent(percent)} ·{' '}
        {reached ? 'soglia raggiunta' : `manca ${formatPercent(100 - percent)} al minimo d’ordine`}
      </span>
    </div>
  )
}
